// extracted by mini-css-extract-plugin
export default {"files":"file-manager_files__0BSBN","label":"file-manager_label__Qf9TS","file":"file-manager_file__eY17+"};